import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './authentication/auth.guard';
import { AuthService, BnsightsUtilitiesLibraryModule } from 'bnsights-utilities-library';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BnsightsUtilitiesLibraryModule
  ],
  providers: [
    AuthService,
    AuthGuard    

  ]
})
export class AuthModule { }
